import React from 'react';
import NCNotification from '../../notifications/NCNotification';
import LoadMoreFallback from '../../FeedbackPage/_partials/LoadMoreFallback/LoadMoreFallback';
import GenericError from '../../GenericError';
import s from './NotificationList.scss';
export function getNotificationListDisplayMode({ isFetching, items, errorMessage, hasMore }) {
    if (errorMessage) {
        return 'error';
    } else if (isFetching || items.length === 0 && hasMore) {
        return 'fetching';
    }
    return undefined;
}
const NotificationList = ({ items, displayMode, loader, className, onLoadMoreClick })=>{
    return /*#__PURE__*/ React.createElement("div", {
        className: className
    }, items.map((item)=>/*#__PURE__*/ React.createElement(NCNotification, {
            key: item.messageId,
            className: s['notification'],
            notification: item
        })), displayMode === 'fetching' && loader, displayMode === 'error' && /*#__PURE__*/ React.createElement(GenericError, null), onLoadMoreClick && /*#__PURE__*/ React.createElement(LoadMoreFallback, {
        fetchNext: onLoadMoreClick,
        isActive: true
    }));
};
NotificationList.displayName = 'NotificationList';
export default NotificationList;
